
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import SimpleMap from '../../../core/components/Map/SimpleMap.vue';
import SatellitalImagesStrip from '../satellital/SatellitalImagesStrip.vue';
import SinisterActions from './SinisterActions.vue'
import SatellitalBandSelector from '../satellital/SatellitalBandSelector.vue'
import { Bounds, FeatureCollection } from '../../../../features/typescript/MapShapes';
import { ItemWithSinistersApi } from '../../../../features/core/api/ItemWithSinistersApi';
import { SatellitalImage, SatellitalImagesApiList } from '../../../../features/typescript/satellital/satellital_images';
import LoadingIndicator from '../../../core/components/Generics/LoadingIndicator.vue';
import DownloadButton from '../../../core/components/Generics/Buttons/DownloadButton.vue';
import { NDVIInfo, SatellitalLayersInfo, ZonificationInfo } from '../../../../features/typescript/satellital/layers';
import { EventBus, TypeEventBus } from '../../../../features/core/utils';
import { Sinister } from '../../../../features/typescript/sinisters/sinisterInfo';
import moment from 'moment';
import { Note } from '../../../../features/typescript/notes/notes';
import SwitchToggle from '../../../core/components/Generics/SwitchToggle.vue'
import { SatellitalValues } from '../../../typescript/satellital/evolution_chart';
@Component({
  components: {
    SimpleMap,
    SatellitalImagesStrip,
    LoadingIndicator,
    SatellitalBandSelector,
    SinisterActions,
    DownloadButton,
    SwitchToggle
  },
})
export default class SinisterMapLayers extends Vue {
  @Prop({ default: null }) readonly itemPolygon!: FeatureCollection;
  @Prop({ default: () => null }) sinisterInfo!: Sinister;
  @Prop({ default: null }) selectedNoteId!: number | null;
  @Prop({ default: null }) hoveredNoteId!: number | null;
  hiddenImageIds: Array<number | string> = [];

  showNdvi: boolean = false;
  showPolygon: boolean = true;
  pendingSatellitalImages: boolean = false;
  pendingLayersInfo: boolean = false;
  showZonification: boolean = false;
  satellitalLayersInfo: SatellitalLayersInfo = {
    zonified: {
      date: null,
      png_url: null,
      bar_url: '',
      total_area: null,
      zones: [],
      bounds: null
    },
    ndvi: {
       initial_date: null,
        final_date: null,
       bar_url: '',
       png_url: null,
        total_area: null,
        zones: [],
        bounds: null
    }
  };

  imagesGroupedByBand: SatellitalImagesApiList = {};
  bands: string[] = [];
  selectedBand: string | null = null;
  visibleNotes: boolean = true;
  mapIsSatellital: boolean = true;
  notes: Note[] = [];

  imagesOfBand: SatellitalImage[] = [];
  selectedImage: SatellitalImage | null = null;
  private lastBaseUrl: string | null = null;
  currentCarouselIndex: number = 0;
  rgbAndNdviValues: SatellitalValues = {
      NDVI: [],
      RGB: []
  }

  private refreshActiveOverlays() {
  if (this.mapRef) {
    if (this.showZonification) {
      this.hideZonif();
      this.drawZonif();
    }
    if (this.showNdvi) {
      this.hideNdvi();
      this.drawNdvi();
    }
  }
}


    get activeLegendUrl(): string | null {
      if (this.showZonification) {
        return this.satellitalLayersInfo.zonified.bar_url
      }
      if (this.showNdvi) {
          return this.satellitalLayersInfo.ndvi.bar_url
      }
      if(this.selectedImage && this.selectedImage.bar_url){
        return this.selectedImage.bar_url
      }

       return null;
    }


  @Watch('satellitalLayersInfo', { deep: true })
  onLayersInfoDeepChange(value) {
    console.log('cambio en las capas satelitales', value)
    this.refreshActiveOverlays();
  }


  onVisibleNotesChange(value: boolean) {
    if (value) {
      this.seeNotesInMap(this.notes);
    } else {
      if (this.mapRef) {
        this.mapRef.removeRanchNotesMarkers();
      }
    }
  }

  created(){
    this.fetchData();
  }

  seeNotesInMap(notes: Note[]) {
    let self = this;
    this.notes = notes;
    if(this.mapRef){
      // displayRanchNotesMarkers limpia y repinta (y cierra el detalle solo si la nota ya no esta)
      this.$nextTick(() => {
        const markersWithLocation: Array<object> = [...notes].filter(note => note['location'] != null);
        self.mapRef.displayRanchNotesMarkers(markersWithLocation);
      })
    }
  }

  private applyInitialSelection() {
  let imgs = this.imagesOfBand || [];
  if (!imgs.length) {
    this.changeCarouselIndex(-1);
    this.selectedImage = null;
    this.onSelectedImageChange(null);
    return;
  }

  let idx = imgs.length - 1;

  let eventDateStr = (this.sinisterInfo && this.sinisterInfo.event_date) ? this.sinisterInfo.event_date : null;
  if (eventDateStr) {
    let eventDate = moment(eventDateStr);
    for (let i = 0; i < imgs.length; i++) {
      if (moment(imgs[i].date).isAfter(eventDate)) {
        idx = i;
        break;
      }
    }
  }

  this.changeCarouselIndex(idx);
  this.selectedImage = imgs[idx];
  this.onSelectedImageChange(this.selectedImage);
}

  get currentZonifiedDate() {
    if (
      this.satellitalLayersInfo &&
      this.satellitalLayersInfo.zonified &&
      this.satellitalLayersInfo.zonified.date
    ) {
      return this.satellitalLayersInfo.zonified.date;
    }
    return null;
  }



   get zonificationDisabled() {
    return (
      this.pendingLayersInfo ||
      !(
        this.satellitalLayersInfo &&
        this.satellitalLayersInfo.zonified &&
        this.satellitalLayersInfo.zonified.png_url
      )
    );
  }

  get zonificationTooltip() {
    if (this.pendingLayersInfo) return 'Cargando zonificación...';
    if (
      !(
        this.satellitalLayersInfo &&
        this.satellitalLayersInfo.zonified &&
        this.satellitalLayersInfo.zonified.png_url
      )
    ) {
      return 'No hay imagen de zonificación';
    }
    return '';
  }

  get polygonDisabled() {
    return !this.itemPolygon; 
  }

  get polygonTooltip() {
    if (!this.itemPolygon) return 'No hay polígono disponible';
    return '';
  }

  get ndviDisabled() {
    return (
      this.pendingLayersInfo ||
      !(
        this.satellitalLayersInfo &&
        this.satellitalLayersInfo.ndvi &&
        this.satellitalLayersInfo.ndvi.png_url
      )
    );
  }

  get ndviTooltip() {
    if (this.pendingLayersInfo) return 'Cargando diferencial NDVI...';
    if (
      !(
        this.satellitalLayersInfo &&
        this.satellitalLayersInfo.ndvi &&
        this.satellitalLayersInfo.ndvi.png_url
      )
    ) {
      return 'No hay imagen NDVI disponible';
    }
    return '';
  }

  get mapRef(): any {
    return this.$refs.sinisterMap;
  }



  showBase() {
    const url   = this.selectedImage && this.selectedImage.png_url;
    const bounds= this.selectedImage && this.selectedImage['bounds'];
    if (!url || !bounds || !this.mapRef) return;

    if (this.lastBaseUrl) {
      this.mapRef.hideGroundOverlayFromMap(this.lastBaseUrl);
    }
    this.mapRef.setGroundOverlayInMap(url, bounds, true);
    this.lastBaseUrl = url;
  }

  showZonif() {
    const z = this.satellitalLayersInfo && this.satellitalLayersInfo.zonified;
    const url = z && z.png_url;
    const bounds = z && z['bounds'];
    if (url && bounds && this.mapRef) this.mapRef.setGroundOverlayInMap(url, bounds, false);
  }

  hideZonif() {
    const z = this.satellitalLayersInfo && this.satellitalLayersInfo.zonified;
    const url = z && z.png_url;
    if (url && this.mapRef) this.mapRef.hideGroundOverlayFromMap(url);
  }

  hideNdvi() {
    const n = this.satellitalLayersInfo && this.satellitalLayersInfo.ndvi;
    const url = n && n.png_url;
    if (url && this.mapRef) this.mapRef.hideGroundOverlayFromMap(url);
  }

  hideAllOverlays() {
    if (this.mapRef) this.mapRef.hideGroundOverlaysFromMap();
    this.lastBaseUrl = null;
  }

  toggleShowZonification() {
    this.showZonification = !this.showZonification;

    if (this.showZonification) {
      if (this.showNdvi) {
        this.showNdvi = false;
        this.hideNdvi();
      }
      this.drawZonif();
    } else {
      this.hideZonif();
    }
  }

  drawZonif() {
    const z = this.satellitalLayersInfo && this.satellitalLayersInfo.zonified;
    const url = z && z.png_url;
    const bounds = z && z.bounds;
    if (url && bounds && this.mapRef) this.mapRef.setGroundOverlayInMap(url, bounds, false);
  }

  toggleShowNdvi() {
    this.showNdvi = !this.showNdvi;

    if (this.showNdvi) {
      if (this.showZonification) {
        this.showZonification = false;
        this.hideZonif();
      }
      this.drawNdvi();
    } else {
      this.hideNdvi();
    }
  }

  drawNdvi() {
    const n = this.satellitalLayersInfo && this.satellitalLayersInfo.ndvi;
    const url = n && n.png_url;
    const bounds = n.bounds;
    if (url && bounds && this.mapRef) this.mapRef.setGroundOverlayInMap(url, bounds, false);
  }

  async fetchData() {
    this.pendingSatellitalImages = true;
    this.pendingLayersInfo = true;

    const imagesP = ItemWithSinistersApi.getSatellitalImages(this.sinisterInfo.id);
    

    this.changeLoadingMap(true)
    imagesP
      .then((response) => {
        let images = response['images'];
        this.rgbAndNdviValues = response['values'];
        this.imagesGroupedByBand = images;
        this.bands = Object.keys(images);
        this.selectedBand = this.bands[0] || null;
        this.onBandChange(this.selectedBand)
        this.imagesOfBand = this.selectedBand ? this.imagesGroupedByBand[this.selectedBand] : [];
        this.applyInitialSelection();
        this.showBase();
      })
      .catch((e) => console.error('Error imágenes', e))
      .finally(() => {
        this.pendingSatellitalImages = false;
        this.refreshLayersInfo();
        this.processingNdviDiff(false);
        this.processingZonification(false)
      });

    
  }

  refreshLayersInfo(){
    let self = this;
    const layersP = ItemWithSinistersApi.getSatellitalLayers(this.sinisterInfo.id);
    layersP
      .then((layersInfo: SatellitalLayersInfo) => {
        this.satellitalLayersInfo = layersInfo;
        console.log('satellitalInfoChanged', layersInfo)
        this.satellitalInfoChanged(layersInfo)

        if (this.showZonification) this.showZonif();
        if (this.showNdvi) this.drawNdvi();
      })
      .catch((e) => console.error('Error layers', e))
      .finally(() => {
          this.pendingLayersInfo = false;
          this.emitRgbNdviToChart(this.rgbAndNdviValues);
      });
  }
  

  onSelectBand(band: string | null) {
    this.selectedBand = band;
    this.onBandChange(band);

    this.imagesOfBand = band ? (this.imagesGroupedByBand[band] || []) : [];

    this.applyInitialSelection();
    this.showBase();
  }

  clickedSatelliteImage(index: number, image?: any) {
    if (index === -1) {
      this.changeCarouselIndex(-1);
      this.selectedImage = null;
      this.onSelectedImageChange(null);
      if (this.lastBaseUrl && this.mapRef) {
        this.mapRef.hideGroundOverlayFromMap(this.lastBaseUrl);
        this.lastBaseUrl = null;
      }
      return;
    }

    const img = image || (this.imagesOfBand && this.imagesOfBand[index]);
    if (!img) return;

    if (this.showZonification) {
      this.showZonification = false;
      this.hideZonif();
    }
    
    if (this.showNdvi) {
      this.showNdvi = false;
      this.hideNdvi();
    }

    this.changeCarouselIndex(index);
    this.selectedImage = img;
    this.onSelectedImageChange(img);
    this.showBase();
  }

  changeCarouselIndex(newValue: number){
    this.currentCarouselIndex = newValue
  }

  @Emit()
  emitRgbNdviToChart(values){}

  @Emit('select-note')
  onSelectNote(noteId: number | null) {
    return noteId;
  }

  @Emit()
  @Watch('currentCarouselIndex')
  onCarouselIndexChange(value){}

  @Emit()
  onSelectedImageChange(value){}

  @Emit()
  processingZonification(value){}

  @Emit()
  processingNdviDiff(value){}

  onSuccessZonified(newZonifiedInfo: ZonificationInfo){
    this.satellitalLayersInfo.zonified = newZonifiedInfo;
    this.satellitalInfoChanged(this.satellitalLayersInfo)
  }

  onSuccessNDVIDiff(newNDVIInfo: NDVIInfo){
    this.satellitalLayersInfo.ndvi = newNDVIInfo;
    this.satellitalInfoChanged(this.satellitalLayersInfo)
  }

  @Emit()
  satellitalInfoChanged(newData: SatellitalLayersInfo){}

  @Emit()
  changeLoadingMap(value: boolean){}

  @Emit()
  onBandChange(value: string | null){}

}
